/** Meta reutilizable — matriz §12 docs/proteccion-frontend.md */
const auth = { requiresAuth: true };
const authCurso = { requiresAuth: true, requiresCurso: true };
const tesorero = { requiresAuth: true, requiresCurso: true, requiresRoles: ["treasurer"] };
const directiva = { requiresAuth: true, requiresCurso: true, requiresDirectiva: true };
const directivaMiembro = {
  requiresAuth: true,
  requiresCurso: true,
  requiresDirectivaMiembro: true,
};
const directivaConfig = {
  requiresAuth: true,
  requiresCurso: true,
  requiresDirectivaConfig: true,
};
const cpa = { requiresAuth: true, requiresCurso: true, requiresCpaDirectiva: true };
const cursoCC = {
  requiresAuth: true,
  requiresCurso: true,
  requiresTreasuryType: "centro_costos",
};
const cursoCuotas = {
  requiresAuth: true,
  requiresCurso: true,
  requiresTreasuryType: "cuotas",
};
const tesoreroCC = {
  requiresAuth: true,
  requiresCurso: true,
  requiresRoles: ["treasurer"],
  requiresTreasuryType: "centro_costos",
};
const tesoreroCuotas = {
  requiresAuth: true,
  requiresCurso: true,
  requiresRoles: ["treasurer"],
  requiresTreasuryType: "cuotas",
};

export default [
  {
    path: "/user/mensajeria",
    name: "messaging-conversations",
    component: () => import("@/views/user/mensajeria/ConversacionesView.vue"),
    meta: { ...auth, appSection: "messaging" },
  },
  {
    path: "/user/mensajeria/conversaciones/:conversationId",
    name: "messaging-conversation",
    component: () => import("@/views/user/mensajeria/ConversacionView.vue"),
    meta: { ...auth, appSection: "messaging", hideHeader: true, hideBottomNav: true },
    props: true,
  },
  {
    path: "/user/mensajeria/no-disponible",
    name: "messaging-unavailable",
    component: () =>
      import("@/views/user/mensajeria/MessagingUnavailableView.vue"),
    meta: { ...auth, appSection: "messaging" },
  },
  {
    path: "/user/activities",
    name: "activities-hub",
    component: () => import("@/views/user/ActivitiesHubView.vue"),
    meta: { ...auth, appSection: "activities" },
  },
  {
    path: "/user/me",
    name: "me-hub",
    component: () => import("@/views/user/MeHubView.vue"),
    meta: { ...auth, appSection: "me" },
  },
  {
    path: "/user/main-view",
    name: "main-view",
    component: () => import("@/views/user/MainView.vue"),
    meta: { ...auth, appSection: "treasury" },
  },
  {
    path: "/user/mis-pagos",
    name: "mis-pagos",
    props: true,
    component: () => import("@/views/user/MisPagos.vue"),
    meta: authCurso,
  },
  {
    path: "/user/rendir-gasto",
    name: "rendir-gasto",
    component: () => import("@/views/user/RendirGasto.vue"),
    meta: tesorero,
  },
  {
    path: "/user/registrar-por-rendir",
    name: "registrar-por-rendir",
    component: () => import("@/views/user/RegistrarPorRendir.vue"),
    meta: tesorero,
  },
  {
    path: "/user/registrar-gasto",
    name: "registrar-gasto",
    component: () => import("@/views/user/RegistrarGasto.vue"),
    meta: tesorero,
  },
  {
    path: "/user/editar-gasto/:school_id/:year/:course_code/:expense_id",
    name: "editar-gasto",
    component: () => import("@/views/user/RegistrarGasto.vue"),
    meta: tesorero,
  },
  {
    path: "/user/crear-cobro",
    name: "crear-cobro",
    component: () => import("@/views/user/CrearCobro.vue"),
    meta: tesoreroCuotas,
  },
  {
    path: "/user/admin-cobros",
    name: "admin-cobros",
    component: () => import("@/views/user/AdministrarCobros.vue"),
    meta: tesoreroCuotas,
  },
  {
    path: "/user/modificar-directiva",
    name: "modificar-directiva",
    component: () => import("@/views/user/ModificarDirectiva.vue"),
    meta: directivaMiembro,
  },
  {
    path: "/user/ver-rendiciones",
    name: "ver-rendiciones",
    component: () => import("@/views/user/VerRendiciones.vue"),
    meta: tesorero,
  },
  {
    path: "/user/ver-pagos-generales",
    name: "ver-pagos-generales",
    component: () => import("@/views/user/VerPagosGenerales.vue"),
    meta: authCurso,
  },
  {
    path: "/user/ver-pagos-usuario",
    name: "ver-pagos-usuario",
    component: () => import("@/views/user/MisPagos.vue"),
    meta: directiva,
  },
  {
    path: "/user/ver-gastos-curso",
    name: "ver-gastos",
    component: () => import("@/views/user/VerGastosCurso.vue"),
    meta: authCurso,
  },
  {
    path: "/user/menu-demos",
    name: "menu-demos",
    component: () => import("@/views/user/MenuDemos.vue"),
    meta: auth,
  },
  {
    path: "/password-recovery",
    name: "password-recovery",
    component: () => import("@/views/PasswordRecovery.vue"),
    meta: { requiresAuth: false, hideBottomNav: true, hideHeader: true },
  },
  {
    path: "/user/email-masivo",
    name: "email-masivo",
    component: () => import("@/views/user/EmailMasivo.vue"),
    meta: directiva,
  },
  {
    path: "/user/cpa/gestionar-cursos",
    name: "cpa-gestionar-cursos",
    component: () => import("@/views/user/cpa/GestionarCursosCpa.vue"),
    meta: cpa,
  },
  {
    path: "/user/cpa/crear-cursos",
    name: "cpa-crear-cursos",
    component: () => import("@/views/user/cpa/CrearCursosCpa.vue"),
    meta: cpa,
  },
  {
    path: "/user/cpa/crear-link-asociacion-directivas",
    name: "crear-link-asociacion-directivas",
    component: () =>
      import("@/views/user/cpa/CrearLinkAsociacionDirectivas.vue"),
    meta: cpa,
  },
  {
    path: "/user/cpa/email-masivo-cpa",
    name: "email-masivo-cpa",
    component: () => import("@/views/user/cpa/EmailMasivo.vue"),
    meta: cpa,
  },
  {
    path: "/user/credito-disponible",
    name: "credito-disponible",
    component: () => import("@/views/user/CreditoDisponible.vue"),
    meta: authCurso,
  },
  {
    path: "/user/ver-ingresos-curso",
    name: "ver-ingresos",
    component: () => import("@/views/user/VerIngresosCurso.vue"),
    meta: authCurso,
  },
  {
    path: "/user/registrar-ingreso",
    name: "registrar-ingreso",
    component: () => import("@/views/user/RegistrarIngreso.vue"),
    meta: tesorero,
  },
  {
    path: "/user/resumen-tesoreria",
    name: "resumen-tesoreria",
    component: () => import("@/views/user/ResumenTesoreria.vue"),
    meta: tesorero,
  },
  {
    path: "/user/crear-curso",
    name: "crear-curso",
    component: () => import("@/views/user/CrearGrupoWizard.vue"),
    meta: auth,
  },
  {
    path: "/user/crear-curso-legacy",
    name: "crear-curso-legacy",
    component: () => import("@/views/user/CrearCursoGlobal.vue"),
    meta: auth,
  },
  {
    path: "/user/crear-curso-institucion",
    name: "crear-curso-institucion",
    component: () =>
      import("@/views/user/CrearCursoInstitucionGenerica.vue"),
    meta: auth,
  },
  {
    path: "/user/crear-link-asociacion-curso",
    name: "crear-link-asociacion-curso",
    component: () => import("@/views/user/CrearLinkAsociacionAGrupo.vue"),
    meta: directiva,
  },
  {
    path: "/user/validar-pagos",
    name: "validar-pagos",
    component: () => import("@/views/user/ValidarPagos.vue"),
    meta: tesorero,
  },
  {
    path: "/user/mis-comprobantes",
    name: "mis-comprobantes",
    redirect: { name: "mis-pagos" },
    meta: authCurso,
  },
  {
    path: "/user/ver-info-curso",
    name: "ver-info-curso",
    component: () => import("@/views/user/VerInfoCurso.vue"),
    meta: authCurso,
  },
  {
    path: "/user/ver-usuarios",
    name: "ver-usuarios",
    component: () => import("@/views/user/VerApoderados.vue"),
    meta: directiva,
  },
  {
    path: "/curso/segundo-pupilo",
    name: "curso-segundo-pupilo",
    component: () => import("@/views/user/SegundoPupiloReview.vue"),
    meta: auth,
  },
  {
    path: "/curso/solicitudes-ingreso",
    name: "curso-solicitudes-ingreso",
    component: () => import("@/views/user/CourseJoinReview.vue"),
    meta: auth,
  },
  {
    // Compatibilidad con enlaces antiguos
    path: "/user/ver-apoderados",
    redirect: { name: "ver-usuarios" },
  },
  {
    path: "/user/ver-usuarios-grupo",
    name: "ver-usuarios-grupo",
    component: () => import("@/views/user/VerUsuariosGrupo.vue"),
    meta: authCurso,
  },
  {
    path: "/user/demos/:demoId",
    name: "demo-video",
    component: () => import("@/views/user/demos/DemoVideo.vue"),
    meta: auth,
    props: true,
  },
  {
    path: "/user/cpa/funcionarios",
    name: "cpa-funcionarios",
    component: () => import("@/views/user/cpa/funcionarios/FuncionariosAdminView.vue"),
    meta: cpa,
  },
  {
    path: "/user/cpa/socios",
    name: "cpa-socios",
    component: () => import("@/views/user/cpa/socios/SociosAdminView.vue"),
    meta: cpa,
  },
  {
    path: "/user/asignaciones",
    name: "asignaciones-home",
    component: () => import("@/views/user/asignaciones/AsignacionesHomeView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId",
    name: "asignaciones-proceso",
    component: () => import("@/views/user/asignaciones/AsignacionesProcesoView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId/preferencias",
    name: "asignaciones-preferencias",
    component: () => import("@/views/user/asignaciones/AsignacionesPreferenciasView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId/participantes",
    name: "asignaciones-participantes",
    component: () => import("@/views/user/asignaciones/AsignacionesParticipantesView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId/restricciones",
    name: "asignaciones-restricciones",
    component: () => import("@/views/user/asignaciones/AsignacionesRestriccionesView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId/recursos",
    name: "asignaciones-recursos",
    component: () => import("@/views/user/asignaciones/AsignacionesRecursosView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId/cupos",
    name: "asignaciones-cupos",
    component: () => import("@/views/user/asignaciones/AsignacionesCuposView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/asignaciones/:processId/vocacional",
    name: "asignaciones-vocacional",
    component: () => import("@/views/user/asignaciones/AsignacionesVocacionalView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/cpa/kiosco/usuarios",
    name: "cpa-kiosk-users",
    component: () => import("@/views/user/cpa/kiosco/KioskUsersAdminView.vue"),
    meta: cpa,
  },
  {
    path: "/user/cpa/validacion-ingreso",
    name: "cpa-validacion-ingreso",
    component: () => import("@/views/user/cpa/ValidacionIngresoHubView.vue"),
    meta: { ...cpa, appSection: "activities" },
  },
  {
    path: "/user/ver-directivas",
    name: "ver-directivas",
    component: () => import("@/views/user/cpa/VerDirectivas.vue"),
    meta: cpa,
  },
  {
    path: "/user/ver-cobros",
    name: "ver-cobros",
    component: () => import("@/views/user/VerCobros.vue"),
    meta: cursoCuotas,
  },
  {
    path: "/user/gestion-centro-costos",
    name: "gestion-centro-costos",
    component: () => import("@/views/user/GestionCentroCostos.vue"),
    meta: cursoCC,
  },
  {
    path: "/user/detalle-fondo/:school_id/:year/:course_code/:cc_id",
    name: "detalle-fondo",
    component: () => import("@/views/user/DetalleFondo.vue"),
    meta: cursoCC,
    props: true,
  },
  {
    path: "/user/fondo-individual/:school_id/:year/:course_code/:cc_id",
    name: "fondo-individual",
    component: () => import("@/views/user/FondoIndividual.vue"),
    meta: cursoCC,
    props: true,
  },
  {
    path: "/user/eliminados",
    name: "eliminados",
    component: () => import("@/views/user/Eliminados.vue"),
    meta: tesorero,
  },
  {
    path: "/user/registrar-abonos-por-cc",
    name: "registrar-abonos-por-cc",
    component: () => import("@/views/user/RegistrarAbonosPorCC.vue"),
    meta: cursoCC,
  },
  {
    path: "/user/mis-deudas",
    name: "mis-deudas",
    component: () => import("@/views/user/MisDeudas.vue"),
    meta: cursoCC,
  },
  {
    path: "/user/registrar-abono-centro-costo",
    name: "registrar-abono-centro-costo",
    component: () => import("@/views/user/RegistrarAbonoCentroCosto.vue"),
    meta: cursoCC,
  },
  {
    path: "/user/abonar-cobros-v2",
    name: "abonar-cobros-v2",
    component: () => import("@/views/user/AbonarCobrosV2.vue"),
    meta: cursoCuotas,
  },
  {
    path: "/user/abonar-cobros-cuotas",
    name: "abonar-cobros-cuotas",
    component: () => import("@/views/user/AbonarCobrosCuotas.vue"),
    meta: cursoCuotas,
  },
  {
    path: "/user/reasignar-pagos",
    name: "reasignar-pagos",
    component: () => import("@/views/user/ReasignarPagos.vue"),
    meta: tesorero,
  },
  {
    path: "/user/devolver-dinero",
    name: "devolver-dinero",
    component: () => import("@/views/user/DevolverDinero.vue"),
    meta: tesorero,
  },
  {
    path: "/user/tipo-tesoreria",
    name: "tipo-tesoreria",
    component: () => import("@/views/user/TipoTesoreria.vue"),
    meta: directivaConfig,
  },
  {
    path: "/user/eventos",
    name: "eventos-list",
    component: () => import("@/views/user/eventos/EventosListView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/eventos/mis-entradas",
    name: "eventos-mis-entradas",
    component: () => import("@/views/user/eventos/MisEntradasView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/eventos/mis-entradas/:eventId/:passId",
    name: "evento-entrada",
    component: () => import("@/views/user/eventos/EntradaDetalleView.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/eventos-staff",
    name: "eventos-staff-list",
    component: () => import("@/views/user/eventos/EventosStaffListView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/eventos-staff/:eventId/validar",
    name: "eventos-staff-validar",
    component: () => import("@/views/user/eventos/EventoValidarEntradaView.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/galerias",
    name: "galerias-list",
    component: () =>
      import("@/views/user/galerias/GaleriasPublicListView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/galerias/:slug",
    name: "galerias-public-detalle",
    component: () =>
      import("@/views/user/galerias/GaleriasPublicDetailView.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/calendario",
    name: "user-calendario",
    component: () =>
      import("@/views/user/calendario/CalendarAgendaView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/calendario/:eventId",
    name: "user-calendario-evento",
    component: () =>
      import("@/views/user/calendario/CalendarEventDetailView.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/eventos/:eventId",
    name: "evento-compra",
    component: () => import("@/views/user/eventos/EventoCompraView.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/ventas/mis-pedidos",
    name: "mis-pedidos",
    component: () => import("@/views/user/ventas/MisPedidos.vue"),
    meta: authCurso,
  },
  {
    path: "/user/ventas/mis-pedidos/:eventId/:orderId",
    name: "mi-pedido-detalle",
    component: () => import("@/views/user/ventas/MiPedidoDetalle.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/ventas/compras-curso",
    name: "compras-curso",
    redirect: { name: "ventas-list" },
    meta: authCurso,
  },
  {
    path: "/user/ventas/compras-curso/:eventId",
    name: "compra-curso-detalle",
    component: () => import("@/views/user/ventas/CompraCursoDetalle.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/ventas",
    name: "ventas-list",
    component: () => import("@/views/user/ventas/VentasList.vue"),
    meta: authCurso,
  },
  {
    path: "/user/ventas/:eventId",
    name: "venta-detalle",
    component: () => import("@/views/user/ventas/VentaDetalle.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/gestion-ventas",
    name: "gestion-ventas",
    component: () => import("@/views/user/ventas/GestionVentas.vue"),
    meta: tesorero,
  },
  {
    path: "/user/crear-evento-venta",
    name: "crear-evento-venta",
    component: () => import("@/views/user/ventas/CrearEventoVenta.vue"),
    meta: tesorero,
  },
  {
    path: "/user/gestion-ventas/:eventId",
    name: "admin-evento-venta",
    component: () => import("@/views/user/ventas/AdminEventoVenta.vue"),
    meta: tesorero,
    props: true,
  },
  {
    path: "/user/donaciones/mis-aportes",
    name: "mis-aportes",
    component: () => import("@/views/user/donaciones/MisAportes.vue"),
    meta: authCurso,
  },
  {
    path: "/user/donaciones/mis-aportes/:campaignId/:commitmentId",
    name: "mi-aporte-detalle",
    component: () => import("@/views/user/donaciones/MiAporteDetalle.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/donaciones/aportes-curso",
    name: "aportes-curso",
    redirect: { name: "donaciones-list" },
    meta: authCurso,
  },
  {
    path: "/user/donaciones/aportes-curso/:campaignId",
    name: "aporte-curso-detalle",
    component: () => import("@/views/user/donaciones/AporteCursoDetalle.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/donaciones",
    name: "donaciones-list",
    component: () => import("@/views/user/donaciones/DonacionesList.vue"),
    meta: authCurso,
  },
  {
    path: "/user/donaciones/:campaignId",
    name: "donacion-detalle",
    component: () => import("@/views/user/donaciones/DonacionDetalle.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/gestion-donaciones",
    name: "gestion-donaciones",
    component: () => import("@/views/user/donaciones/GestionDonaciones.vue"),
    meta: tesorero,
  },
  {
    path: "/user/crear-campana-donacion",
    name: "crear-campana-donacion",
    component: () => import("@/views/user/donaciones/CrearCampanaDonacion.vue"),
    meta: tesorero,
  },
  {
    path: "/user/gestion-donaciones/:campaignId",
    name: "admin-campana-donacion",
    component: () => import("@/views/user/donaciones/AdminCampanaDonacion.vue"),
    meta: tesorero,
    props: true,
  },
  {
    path: "/user/clasificados",
    name: "clasificados-home",
    component: () => import("@/views/user/clasificados/ClasificadosHomeView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/clasificados/listado",
    name: "clasificados-list",
    component: () => import("@/views/user/clasificados/ClasificadosListView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/clasificados/nuevo",
    name: "clasificados-nuevo",
    component: () => import("@/views/user/clasificados/ClasificadosNuevoView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/clasificados/mis-avisos",
    name: "clasificados-mis-avisos",
    component: () => import("@/views/user/clasificados/ClasificadosMisAvisosView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/clasificados/mis-interacciones",
    name: "clasificados-mis-interacciones",
    component: () =>
      import("@/views/user/clasificados/ClasificadosMisInteraccionesView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/clasificados/:listingId",
    name: "clasificados-detalle",
    component: () => import("@/views/user/clasificados/ClasificadosDetalleView.vue"),
    meta: authCurso,
    props: true,
  },
  {
    path: "/user/retiros",
    name: "mis-retiros",
    component: () => import("@/views/user/retiros/MisRetirosView.vue"),
    meta: { ...authCurso, requiresPupilCourse: true },
  },
  {
    path: "/user/retiros/nuevo",
    name: "crear-retiro",
    component: () => import("@/views/user/retiros/CrearRetiroView.vue"),
    meta: { ...authCurso, requiresPupilCourse: true },
  },
  {
    path: "/user/retiros/:withdrawalId",
    name: "retiro-detalle",
    component: () => import("@/views/user/retiros/RetiroDetalleView.vue"),
    meta: { ...authCurso, requiresPupilCourse: true },
    props: true,
  },
  {
    path: "/user/retiros-staff/validar",
    name: "validar-retiro",
    component: () => import("@/views/user/retiros/ValidarRetiroView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/retiros-staff/escanear-barcode-poc",
    name: "escanear-barcode-poc",
    component: () => import("@/views/user/retiros/EscanearBarcodePocView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/retiros-staff/dia",
    name: "retiros-dia-guardia",
    component: () => import("@/views/user/retiros/GuardiaRetirosDiaView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/retiros-staff/tablero",
    name: "tablero-retiros",
    component: () => import("@/views/user/retiros/TableroRetirosView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/inspector/validar-ingreso",
    name: "validar-ingreso",
    component: () => import("@/views/user/inspector/ValidarIngresoView.vue"),
    meta: { ...authCurso, appSection: "activities" },
  },
  {
    path: "/user/inspector/apoderados",
    name: "inspector-apoderados",
    component: () => import("@/views/user/inspector/InspectorApoderadosView.vue"),
    meta: { ...authCurso, appSection: "activities" },
  },
  {
    path: "/user/inspector/apoderados/:email",
    name: "inspector-apoderado-detalle",
    component: () =>
      import("@/views/user/inspector/InspectorApoderadoDetalleView.vue"),
    meta: { ...authCurso, appSection: "activities" },
    props: true,
  },
  {
    path: "/user/inspector/logs-qr",
    name: "inspector-qr-logs",
    component: () => import("@/views/user/inspector/InspectorQrLogsView.vue"),
    meta: { ...authCurso, appSection: "activities" },
  },
  {
    path: "/user/transporte",
    name: "transporte",
    component: () => import("@/views/user/transporte/TransporteDriverHomeView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/transporte/viaje",
    name: "transporte-viaje",
    component: () => import("@/views/user/transporte/TransporteViajeView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/transporte/rutas",
    name: "transporte-rutas",
    component: () => import("@/views/user/transporte/TransporteRutasView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/transporte/solicitudes",
    name: "transporte-solicitudes",
    component: () =>
      import("@/views/user/transporte/TransporteSolicitudesView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/transporte/buscar",
    name: "transporte-buscar",
    component: () => import("@/views/user/transporte/TransporteBuscarView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/transporte/mis",
    name: "transporte-mis",
    component: () => import("@/views/user/transporte/TransporteMisView.vue"),
    meta: authCurso,
  },
  {
    path: "/user/transporte/mapa",
    name: "transporte-mapa",
    component: () => import("@/views/user/transporte/TransporteMapaView.vue"),
    meta: authCurso,
  },
  {
    path: "/compartir-archivo",
    name: "compartir-archivo",
    component: () => import("@/views/user/CompartirArchivo.vue"),
    meta: auth,
  },
];
